import { BellAlertIcon, BellSlashIcon } from "@heroicons/react/24/outline";
import { ColumnDef } from "@tanstack/react-table";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { DetailedUser } from "@/user/user.d";

const Content = ({
  notificationsEnabled,
  email,
}: {
  notificationsEnabled: boolean;
  email: string;
}) => (
  <>
    <Tooltip>
      <TooltipTrigger asChild>
        {notificationsEnabled ? (
          <BellAlertIcon className="mr-2 inline h-4 w-4" />
        ) : (
          <BellSlashIcon className="mr-2 inline h-4 w-4 text-stroke-secondary" />
        )}
      </TooltipTrigger>
      <TooltipContent>
        Email notifications{" "}
        <b>will {!notificationsEnabled ? "not" : ""} be sent</b> to this user.
      </TooltipContent>
    </Tooltip>
    <span>{email} </span>
  </>
);

export const EmailCol = (): ColumnDef<DetailedUser> => ({
  accessorKey: "email",
  header: "Email",
  cell: ({ getValue, row }) => {
    const notificationsEnabled = row.original.is_notifications_enabled;
    return (
      <Content
        notificationsEnabled={notificationsEnabled}
        email={getValue() as string}
      />
    );
  },
});
